module.exports = __webpack_public_path__ + "static/net-core-551ca5ddedf2f17aa40b963ff63cdac3.png";